<template>
	<div>
		<ValidationObserver
			ref="newsletterForm"
			v-slot="{ invalid, errors }"
			tag="form"
			@submit.prevent="onSubmit"
			novalidate
		>

			<GeneralMessage
				v-if="newsletterResponse.message"
				:message="newsletterResponse.message"
				:type="newsletterResponse.type"
				@close="newsletterResponse.message = ''"
			/>

			<!-- EMAIL -->
			<ValidationProvider
				class="form-row__wrapper"
				name="newsletterEmail"
				rules="required|email"
				v-slot="{ errors, invalid, validated, dirty }"
				tag="div"
				ref="loginEmail"
				:customMessages="{ required: $t('forms.errors.fieldEmpty'), email: $t('forms.errors.emailInvalid') }"
			>
				<FormInput
					type="email"
					:placeholder="$t('forms.labels.email')"
					:label="$t('forms.labels.email')"
					name="newsletterEmail"
					v-model="newsletterForm.email"
					:error="invalid && validated && !!newsletterForm.email"
					:error-message="errors[0]"
					:disabled="disabled"
					required
				/>
			</ValidationProvider>

			<ValidationObserver
				v-if="newsletterForm.email"
				class="form-row__wrapper"
				tag="div"
				ref="name"
				v-slot="{ validated, invalid, errors }"
			>
				<div class="form-group">
					<ValidationProvider
						class="form-group__span--12 form-group__span--md-6"
						name="newsletterFirstname"
						rules="required"
						v-slot="{ errors, invalid }"
						tag="div"
						:customMessages="{ required: $t('forms.errors.fieldEmpty') }"
					>
						<FormInput
							type="text"
							:placeholder="$t('forms.labels.firstname')"
							:label="$t('forms.labels.firstname')"
							name="newsletterFirstname"
							v-model="newsletterForm.firstname"
							:error="errors.length > 0"
							required
						/>
					</ValidationProvider>
					<ValidationProvider
						class="form-group__span--12 form-group__span--md-6"
						name="newsletterLastname"
						rules="required"
						v-slot="{ errors, invalid }"
						tag="div"
						:customMessages="{ required: $t('forms.errors.fieldEmpty') }"
					>
						<FormInput
							type="text"
							:placeholder="$t('forms.labels.lastname')"
							:label="$t('forms.labels.lastname')"
							name="newsletterLastname"
							v-model="newsletterForm.lastname"
							:error="errors.length > 0"
							required
						/>
					</ValidationProvider>
				</div>
				<div
					class="form-input__error | form-input-error form-group__span--12"
					v-if="invalid && validated"
					v-html="joinErrorMessage(errors)"
				/>
			</ValidationObserver>

			<Button
				v-if="newsletterForm.email"
				type="submit"
				level="primary"
				:text="$t('forms.labels.submit')"
				:disabled="disabled"
			/>
		</ValidationObserver>
	</div>
</template>

<script>
import Vue from "vue"
import GenericMixin from '@/mixins/GenericVueMixin';
import { mapGetters } from "vuex"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import FormInput from "@/components/FormInput"
import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'
import { loadRecaptcha, getRecaptchaResponse } from '@/helpers/recaptchaHelper'

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		Button,
		GeneralMessage,
	},
	data() {
		return {
			newsletterForm: {
				email: "",
				firstname: '',
				lastname: '',
			},
			newsletterResponse: {
				type: 'info',
				message: '',
			},
			recaptchaLoaded: false,
		}
	},
	computed: {
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		disabled() {
			return this.loading;
		},
	},
	methods: {
		joinErrorMessage(errors) {
			let messages = [];
			Object.values(errors).filter(value => !!value.join('').trim()).forEach(m => {
				const message = m.join('').trim();
				if (!messages.includes(message)) {
					messages.push(message);
				}
			});
			return messages.join(' ');
		},
		async onSubmit() {
			const isValid = await this.$refs.newsletterForm.validate()
			if (isValid) {
				this.loading = true;
				document.activeElement.blur();
				try {

					const recaptchaResponse = await getRecaptchaResponse();
					const response = await this.$store.dispatch('subscribeNewsletter', {
						...this.newsletterForm,
						recaptchaResponse,
					})
					if (response.redirect && response.redirect.key) {
						return this.$store.dispatch('redirect', {
							name: response.redirect.key,
							params: response.redirect.params || {},
						})
					}

					this.resetForm();
					this.newsletterResponse.message = this.$t('newsletter.success');
					this.newsletterResponse.type = 'success';
				} catch(err) {
					try {
						let message = this.$t('forms.errors.generic')
						const data = err?.response?.data;

						if (data) {
							if (data.redirect && data.redirect.key) {
								return this.$store.dispatch('redirect', {
									name: data.redirect.key,
									params: data.redirect.params || {},
								})
							}

							if (data.errors && data.errors.email) {
								message = data.errors.email[0]
							} else {
								message = data.message
							}
						}

						this.newsletterResponse.message = message;
						// TODO: check for status code and change type
						this.newsletterResponse.type = 'error';
					}
					catch(er) {
						// we don't actually need to do anything here
					}
				}
				this.loading = false;
			}
		},
		resetForm(form, inputs = true) {
			try {
				if (!form || form === 'login') {
					if (inputs) {
						this.newsletterForm.email = '';
						this.newsletterForm.firstname = '';
						this.newsletterForm.lastname = '';
					}
					this.newsletterResponse.message = '';
					this.$refs.newsletterForm.reset();
				}
				if (!form) {
					this.loading = false;
				}
				if (inputs) {
					document.activeElement.blur();
				}
			}
			catch(err) {}
		},
	},
	async created() {
		await loadRecaptcha()
	}
}
</script>

<style>

</style>
